import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { titleSearchRequestsInitialState } from './interfaces';
import { TOrderPayload } from '../../../types/order/vendorDashboard/TOrderPayload';
import { ITitleSearchRequestData } from '../../../types/order/title/ITitleSearchRequest';
import { IRedVisionSearchData } from '../../../types/order/title/IRedVisionSearch';

export const titleSearchRequestsReducer = createSlice({
  name: 'titleSearchRequests',
  initialState: titleSearchRequestsInitialState,
  reducers: {
    setTitleSearchRequestsAction: (state, action: PayloadAction<TOrderPayload<ITitleSearchRequestData[]>>) => {
      state.titleSearchRequest[action.payload.orderId] = action.payload.value;
    },
    setTitleSearchRequestsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.titleSearchRequestFetchStatus = action.payload;
    },
    setTitleSearchRequestsErrorAction: (state, action: PayloadAction<string | null>) => {
      state.titleSearchRequestError = action.payload;
    },
    setRedVisionSearchAction: (state, action: PayloadAction<TOrderPayload<IRedVisionSearchData>>) => {
      state.redVisionSearch[action.payload.orderId] = action.payload.value;
    },
    setRedVisionSearchFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.redVisionSearchFetchStatus = action.payload;
    },
    setRedVisionSearchErrorAction: (state, action: PayloadAction<string | null>) => {
      state.redVisionSearchError = action.payload;
    },
    setCreateTitleSearchRequestsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.createTitleSearchRequestFetchStatus = action.payload;
    },
    setCreateTitleSearchRequestsErrorAction: (state, action: PayloadAction<string | null>) => {
      state.createTitleSearchRequestError = action.payload;
    },
    setCancelTitleSearchRequestsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.cancelTitleSearchRequestFetchStatus = action.payload;
    },
    setCancelTitleSearchRequestsErrorAction: (state, action: PayloadAction<string | null>) => {
      state.cancelTitleSearchRequestError = action.payload;
    },
  },
});

export const {
  setTitleSearchRequestsAction,
  setTitleSearchRequestsErrorAction,
  setTitleSearchRequestsFetchStatusAction,
  setCreateTitleSearchRequestsErrorAction,
  setCreateTitleSearchRequestsFetchStatusAction,
  setCancelTitleSearchRequestsErrorAction,
  setCancelTitleSearchRequestsFetchStatusAction,
  setRedVisionSearchAction,
  setRedVisionSearchErrorAction,
  setRedVisionSearchFetchStatusAction,
} = titleSearchRequestsReducer.actions;
